import { useBranding } from "@/context/BrandingContext";

export default function LogoMark({ size = 44, textClass = "text-2xl", className = "", plain = false }) {
  const { logo } = useBranding();
  const style = { width: size, height: size };

  if (logo) {
    return (
      <img
        src={logo}
        alt="Rizqia Aqiqah"
        style={style}
        className={`object-contain ${plain ? "" : "rounded-xl bg-white"} ${className}`}
        data-testid="brand-logo-img"
      />
    );
  }
  return (
    <div
      style={style}
      className={`ml-0.5 flex items-center justify-center rounded-xl bg-brand-gold font-serif font-bold text-brand-espresso ${textClass} ${className}`}
      data-testid="brand-logo-fallback"
    >
      R
    </div>
  );
}
